import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcDeleteFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m0 10.803 3.074 3.073q.207.209.522.213a.7.7 0 0 0 .531-.213.72.72 0 0 0 .218-.527.72.72 0 0 0-.218-.526l-3.073-3.074 3.073-3.073a.73.73 0 0 0 .213-.522.7.7 0 0 0-.213-.531.72.72 0 0 0-.526-.218.72.72 0 0 0-.527.218L12 10.946 8.927 7.873a.73.73 0 0 0-.522-.213.7.7 0 0 0-.531.213.72.72 0 0 0-.218.526q0 .31.218.527L10.947 12l-3.073 3.074a.72.72 0 0 0-.213.522.7.7 0 0 0 .213.531q.216.218.526.218a.72.72 0 0 0 .527-.218z",
    clipRule: "evenodd"
  }));
}
var IcDeleteFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcDeleteFill));

export { IcDeleteFill as I };
